import React, { FC, useContext } from 'react';
import Dialog from '@mui/material/Dialog';
import { DownloadOfflineLicense } from './DownloadOfflineLicense';
import { LicenseContext } from '../../contexts/LicenseContext';
import { Box, Button, CircularProgress, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { ELicenseMode } from '../../models/ILicense';
import { useTranslation } from 'react-i18next';

interface IProps {
  open: boolean;
  onClose: () => void;
  isLoading?: boolean;
}

export const OfflineAccessStepsDialog: FC<IProps> = ({ open, onClose, isLoading = false }) => {
  const { t } = useTranslation();
  const { mode } = useContext(LicenseContext)!;

  return (
    <Dialog open={open} onClose={onClose}>
      {isLoading ? (
        <>
          <DialogTitle>{t('component.requestOffline.loading')}</DialogTitle>
          <DialogContent>
            <Box display="flex" justifyContent="center" p={3}>
              <CircularProgress />
            </Box>
          </DialogContent>
        </>
      ) : mode === ELicenseMode.Airgap ? (
        <DownloadOfflineLicense onClose={onClose} />
      ) : (
        <>
          <DialogTitle>Request offline license</DialogTitle>
          <DialogContent>Use the button above the table to request offline license</DialogContent>
          <DialogActions>
            <Button variant="text" onClick={onClose}>
              Close
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};
